// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"057c96d1","207":"bae29a99","253":"410f31a0","435":"6ba87e83","628":"f99f7dfb","632":"a27d8019","886":"0b7fee92","898":"19f5a940","900":"90597fbf","911":"1691e0fb"}[chunkId] + ".chunk.js";
};